<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="form.start_date" :is-time="true" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="form.end_date" :is-time="true" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('plate')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(formData.plate) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('kilometer')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(formData.kilometer) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('gear')">
                        <b-input-group>
                            <div class="label-as-input">{{ getLocaleText(formData, 'gear_name') }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('type')">
                        <b-input-group>
                            <div class="label-as-input">{{ getLocaleText(formData, 'type_name') }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>

            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("make_reservation") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import CarReservationEmptyReservationService from "@/services/CarReservationEmptyReservationService";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,

    },
    props: {
        formData: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        formData: {
            immediate: true,
            deep: true,
            handler(val) {
                this.form.start_date = val?.start_date ?? null;
                this.form.end_date   = val?.end_date ?? null;
            },
        },
    },
    data() {
        return {
            formLoading: false,
            form: { start_date: null, end_date: null },
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formData && this.formData.id) {
                this.formLoading = true;

                const formData = {
                    start_date: this.form.start_date,
                    end_date: this.form.end_date,
                    car_id: this.formData.id,
                }

                CarReservationEmptyReservationService.makeReservation(formData)
                    .then((response) => {
                        this.formLoading = false;
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("makeReservationFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    })
            }
        }
    }
}
</script>
